import { axios } from "@/config";
const api = {
  getCurrencyList: '/pay/getCurrencyList',
  getQRCode: '/pay/getQRCode',
  queryOrders: '/pay/queryOrders',
  getBuyExpandSpaceSpecs: '/pay/getBuyExpandSpaceSpecs',
  getBuyExpandSpace: '/pay/getBuyExpandSpace',
  getBuyExpandSpaceDate: '/pay/getBuyExpandSpaceDate',
  caclBuyExpandSpacePrice: '/pay/caclBuyExpandSpacePrice',
  toBuyExpandSpace: '/pay/toBuyExpandSpace'
}

/**
 * 获取充值列表
 * @param {*} data
 */
export function getCurrencyList(data, source) {
  return axios({
    url: api.getCurrencyList,
    method: 'post',
    data,
    source
  })
}

/**
 * 获取支付二维码
 * @param {*} data 
 * @returns 
 */
export function getQRCode(data, source) {
  return axios({
    url: api.getQRCode,
    method: 'post',
    data,
    source
  })
}

/**
 * 查询订单
 * @param {*} data 
 * @returns 
 */
export function queryOrders(data) {
  return axios({
    url: api.queryOrders,
    method: 'post',
    data
  })
}

/**
 * 获取购买扩展空间规格列表
 * @param {*} data 
 * @returns 
 */
export function getBuyExpandSpaceSpecs(data, source) {
  return axios({
    url: api.getBuyExpandSpaceSpecs,
    method: 'post',
    data, 
    source
  })
}

/**
 * 获取购买扩展空间信息
 * @param {*} data 
 * @returns 
 */
export function getBuyExpandSpace(data, source) {
  return axios({
    url: api.getBuyExpandSpace,
    method: 'post',
    data, 
    source
  })
}

/**
 * 获取购买扩展空间时间列表
 * @param {*} data 
 * @returns 
 */
export function getBuyExpandSpaceDate(data, source) {
  return axios({
    url: api.getBuyExpandSpaceDate,
    method: 'post',
    data, 
    source
  })
}

/**
 * 计算购买扩展空间价格
 * @param {*} data 
 * @returns 
 */
export function caclBuyExpandSpacePrice(data, source){
  return axios({
    url: api.caclBuyExpandSpacePrice,
    method: 'post',
    data,
    source
  })
}

/**
 * 去购买扩展空间
 * @param {*} data 
 * @returns 
 */
 export function toBuyExpandSpace(data) {
  return axios({
    url: api.toBuyExpandSpace,
    method: 'post',
    data
  })
}